import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/sections/sustainability-page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/NewsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/PageHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/ProjectStage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/RelatedProject.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/ServiceCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/ServiceCategory.tsx");
